/* eslint-disable consistent-return */

import { h } from 'preact';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { isLauraCanada } from 'utils/helpers';
import clsx from 'clsx';
import Media from 'utils/media';

const SizeGuideTab = ({ sizeGuide }) => {
  const [selectedTableType, setSelectedTableType] = useState('standard_table');
  const [userChangedTableType, setUserChangedTableType] = useState(false);

  useEffect(() => {
    if (!sizeGuide || userChangedTableType) return;
    if (sizeGuide.standard_table && sizeGuide.metric_table) {
      setSelectedTableType('standard_table');
    } else if (sizeGuide.standard_table) setSelectedTableType('standard_table');
    else setSelectedTableType('metric_table');
  }, [sizeGuide]);

  const media = useMemo(() => {
    const result = [];
    if (sizeGuide.image) {
      result.push(sizeGuide.image);
    }
    if (sizeGuide.image) {
      result.push(sizeGuide.video);
    }
    return result;
  }, [sizeGuide]);

  return (
    <div>
      <div className="tab__heading flex items-end justify-between ml:justify-center">
        {!!sizeGuide?.range && isLauraCanada() && (
          <span className="body-3">{sizeGuide?.range}</span>
        )}
        {sizeGuide?.metric_table && sizeGuide?.standard_table ? (
          <div className="flex self-end ml:self-center p-4 border lc:rounded-full border-grey-400">
            <button
              className={clsx(
                'w-[45px] h-[27px] lc:rounded-full text-center body-3',
                {
                  ' bg-black text-white':
                    selectedTableType === 'standard_table',
                  ' bg-white text-black':
                    selectedTableType !== 'standard_table',
                },
              )}
              type="button"
              aria-label="in"
              onClick={() => setSelectedTableType('standard_table')}
            >
              {window.TMW.Strings.sizeGuide.in}
            </button>
            <button
              className={clsx(
                'w-[45px] h-[27px] lc:rounded-full text-center body-3',
                {
                  ' bg-black text-white': selectedTableType === 'metric_table',
                  ' bg-white text-black': selectedTableType !== 'metric_table',
                },
              )}
              type="button"
              aria-label="cm"
              onClick={() => {
                setSelectedTableType('metric_table');
                setUserChangedTableType(true);
              }}
            >
              {window.TMW.Strings.sizeGuide.cm}
            </button>
          </div>
        ) : null}
      </div>
      {(sizeGuide?.standard_table || sizeGuide?.metric_table) && (
        <SizingTable chart={sizeGuide[selectedTableType]} />
      )}

      {sizeGuide?.content?.length > 0 && (
        <div className="mt-24 mb-32 flex flex-col ml:justify-center ml:text-center">
          <p className="body-1-semibold mb-8">
            {window.TMW.Strings.product.howToMeasure}
          </p>
          <div
            className="body-3 [&>div>*]:body-3"
            data-target="text-content"
            dangerouslySetInnerHTML={{ __html: sizeGuide.content }}
          />
        </div>
      )}

      {media?.length > 0 ? (
        <div className="flex flex-col gap-y-32">
          {media.map((item, index) => (
            <Media
              {...item}
              srcWidths={{
                sm: 640,
                md: 768,
                lg: 1024,
                xl: 1280,
                '2xl': 1536,
              }}
              className="w-full h-auto"
              parentClass="h-[445px] md:h-[610.3px] relative"
              key={index}
              controlClass="!bottom-16 !top-auto"
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SizeGuideTab;

const SizingTable = ({ chart }) => {
  const chartHeadings = chart && chart[0] && Object.keys(chart[0]);
  return chart && chart[0] ? (
    <div className="-mr-24 ">
      <div className="overflow-hidden">
        <div className="py-16 ml:py-24 overflow-auto pr-24">
          <table className="w-full table-fixed border-collapse text-center">
            <tr>
              {chartHeadings?.map((item, index) => (
                <th
                  key={index}
                  className="body-3-medium bg-grey-200 px-4 py-[17.5px] border border-grey-400 !w-[88.6px] ml:!w-[111.4px]"
                >
                  {item}
                </th>
              ))}
            </tr>
            {chart.map((row, rowIndex) => (
              <tr
                className="body-3 uppercase odd:bg-grey-200 border-t border--grey-400"
                key={rowIndex}
              >
                {chartHeadings?.map((item, index) => (
                  <td
                    className="py-8 px-2 border border-grey-400 w-[88.6px] ml:w-[111.4px]"
                    key={index}
                  >
                    {row[item] ? row[item] : ''}
                  </td>
                ))}
              </tr>
            ))}
          </table>
        </div>
      </div>
    </div>
  ) : null;
};
